import script from "./CreatedBy.vue?vue&type=script&setup=true&lang=ts"
export * from "./CreatedBy.vue?vue&type=script&setup=true&lang=ts"

import "./CreatedBy.vue?vue&type=style&index=0&id=75cf113b&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75cf113b"]])

export default __exports__